import { BaseAPIModel } from '@weezevent/weezjs-core';

export class Domain extends BaseAPIModel {
    fields() {
        return {
            id: { primaryKey: true, readOnly: true }
        };
    }

    toOptions(i) {
        return { label: `@${this.name}`, value: i + 1, status: this.verification_status };
    }

    isUsed(identities) {
        this.is_used = identities?.some(identity => identity.from_address.email.split('@')[1] === this.name);
        return this.is_used;
    }

    static listUrl({ organizationId }) {
        if (!organizationId) return `/mail/domains`;
        return `/mail/organizations/${organizationId}/domains`;
    }

    get is_success() {
        return this.object.verification_status === 'success';
    }
}
